import { Permissions } from "@cnx/common";
import {
  IconBuildingWarehouse,
  IconShieldLock,
  IconUsers,
} from "@tabler/icons-react";
import { FEATURE_TERMINAL_MANAGEMENT } from "common/constants";
import { useFeatureSupport } from "hooks/useFeatureSupport";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { useAuthStore } from "stores/authStore";
import { Link } from "types/Link";

export const useBasicInfoLinks = () => {
  const useRights = new Set(useAuthStore(state => state.useRights));
  const { t } = useTranslation();
  const { isFeatureEnabled } = useFeatureSupport();
  const { pathname: currentPath } = useLocation();

  const basicInfoLinks: Link[] = [];

  (useRights.has(Permissions.RIGHTS_ROLES_USER) ||
    useRights.has(Permissions.RIGHTS_ROLES_ADMIN)) &&
    basicInfoLinks.push({
      isActive: currentPath.startsWith("/roles"),
      link: "/roles",
      icon: <IconUsers />,
      label: t("roles"),
    });
  useRights.has(Permissions.RIGHTS_USE_RIGHTS_ADMIN) &&
    basicInfoLinks.push({
      isActive: currentPath.startsWith("/features"),
      link: "/features",
      icon: <IconShieldLock />,
      label: t("rights"),
    });
  useRights.has(Permissions.RIGHTS_STAKEHOLDERS_ADMIN) &&
    basicInfoLinks.push({
      isActive: currentPath === "/stakeholders",
      link: "/stakeholders",
      icon: <IconUsers />,
      label: t("stakeholders"),
    });
  useRights.has(Permissions.RIGHTS_TERMINAL_ADMIN) &&
    isFeatureEnabled(FEATURE_TERMINAL_MANAGEMENT) &&
    basicInfoLinks.push({
      isActive: currentPath.startsWith("/terminals"),
      link: "/terminals",
      icon: <IconBuildingWarehouse className="w-[24px] h-[24px]" />,
      label: t("terminals"),
    });

  return basicInfoLinks;
};
